/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ subject: NonNullable<unknown> }} Rights_Drawer_TitleInputs */



/**
* | output |
* | --- |
* | "Rights for {subject}" |
*
* @param {Rights_Drawer_TitleInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const rights_drawer_title = /** @type {((inputs: Rights_Drawer_TitleInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Rights_Drawer_TitleInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Rechte für ${i?.subject}`)
	return /** @type {LocalizedString} */ (`Rights for ${i?.subject}`)
});